module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/33819-b91dce140e238f8351717f8c1d79d160.svg";